"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COOKIE_CONSENT = void 0;
exports.COOKIE_CONSENT = 'obvio-cookie-consent';
